/**
 * Analytics barrel export.
 *
 * Import from "@/lib/analytics" for all analytics-related utilities.
 */

export { analytics, createAnalytics } from "./provider";
export type { AnalyticsProvider } from "./provider";

export type {
  AnalyticsEvent,
  EventName,
  EventProperties,
  EventContext,
  PageViewEvent,
  ClickOpenInAppEvent,
  ClickInstallEvent,
  ClickShareEvent,
  ClickViewPlanEvent,
  SearchPerformedEvent,
  SearchResultClickEvent,
  AppDownloadEvent,
  CtaClickEvent,
  ErrorEvent,
} from "./events";
export { EVENT_NAMES } from "./events";

export {
  extractUtmParams,
  hasUtmParams,
  persistUtmParams,
  getPersistedUtmParams,
  clearPersistedUtmParams,
  appendUtmParams,
  utmToEventContext,
  UTM_KEYS,
} from "./utm";
export type { UtmParams } from "./utm";

export {
  reportWebVital,
  isGoodVital,
  getVitalRating,
  CWV_THRESHOLDS,
} from "./web-vitals";
export type { WebVitalMetric } from "./web-vitals";
